import { render, staticRenderFns } from "./CardTextHeader.vue?vue&type=template&id=3247a6e4&scoped=true"
import script from "./CardTextHeader.vue?vue&type=script&lang=js"
export * from "./CardTextHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247a6e4",
  null
  
)

export default component.exports